import { EAccountTiers, TAddon } from '../../enum';

export const SubscriptionStatuses = [
  'trial',
  'active',
  'cancelled',
  'non_renewing',
  'future',
  'paused',
] as const;
export type TSubscriptionStatus = (typeof SubscriptionStatuses)[number];

export const SubscriptionFrequencies = ['monthly', 'yearly'] as const;
export type TSubscriptionFrequency = (typeof SubscriptionFrequencies)[number];

export const SubscriptionTiers = [
  EAccountTiers.LITE,
  EAccountTiers.PLUS,
  EAccountTiers.PRO,
] as const;
export type TSubscriptionTier = (typeof SubscriptionTiers)[number];

export interface IAddonQuantity {
  addon: TAddon;
  quantity: number;
}

export interface ISubscriptionAddon extends IAddonQuantity {
  frequency: TSubscriptionFrequency;
}

export interface ISubscription {
  accountId: string;
  addons: ISubscriptionAddon[];
  amount: number;
  cancelledAt?: Date;
  createdAt: Date;
  currency: string;
  frequency: TSubscriptionFrequency;
  id: string;
  nextBillingAt: Date;
  status: TSubscriptionStatus;
  tier: TSubscriptionTier;
  trialEnd?: Date;
  updatedAt: Date;
  version: number;
}

export interface ICampaignConfig {
  campaign: string;
  tier: TSubscriptionTier;
  frequency: TSubscriptionFrequency;
  trialLength: number;
  campaignEndAt?: Date;
}

export interface ISignUpTrialConfig {
  tier: TSubscriptionTier;
  frequency: TSubscriptionFrequency;
  trialLength: number | null;
}

export interface ISubscriptionConfig {
  signupTrial?: ISignUpTrialConfig;
  campaigns: ICampaignConfig[];
}

export interface ISubscriptionTier {
  tier: TSubscriptionTier;
  frequency: TSubscriptionFrequency;
  trialEndAt: Date;
}
